module.exports = __webpack_public_path__ + "img/18_69.24ac5252.png";